import React, { useState } from "react";
import Modal from "../../UIComponents/CustomModal/Modal";
import { useSelector } from "react-redux";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";
import "./LinkedinPageSelectionModal.scss";
import Scrollbars from "react-custom-scrollbars";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const LinkedinPageSelectionModal = (props) => {
    const { redirectOnError } = props;
    const history = useHistory();
    const linkedinPageLists = useSelector((state) => state.tokensReducer.linkedinPages || []);
    const { open, selectedPages, setPageList, storePage } = props;
    const [isOpen, setIsOpen] = useState(open);

    const updatePageSelectionList = (type, pageId) => {
        if (type === "remove") {
            let filteredList = selectedPages.filter((id) => id !== pageId);
            setPageList(filteredList);
        } else setPageList((prev) => [...prev, pageId]);
    };

    const handleSelectAllOption = () => {
        if (linkedinPageLists.length === selectedPages.length) {
            // uncheck
            setPageList([]);
        } else {
            let ids = linkedinPageLists.map((page) => page.page_id);
            // console.log("idsss", ids);
            setPageList(ids);
        }
    };

    const handleButtonClick = () => {
        if (selectedPages.length < 1) {
            toast.error("Please select atleast one page to continue");
            return;
        }
        setIsOpen(false);
        storePage();
    };
    const handleCancelAuthentication = () => {
        toast.error("Error in Authorizing");
        history.push(redirectOnError);
    };

    return (
        <Modal className={`linkedin__page__selection__modal`} show={isOpen} onClose={handleCancelAuthentication}>
            <Modal.Header>Select LinkedIn Pages</Modal.Header>
            <Modal.Content className={`page__selection__content__modal`}>
                <p>Please select the pages you want to add.</p>
                <Scrollbars style={{ height: "80%" }}>
                    {linkedinPageLists.length > 0 ? (
                        <div className="page__list__item" key={page.page_id}>
                            <Checkbox checked={linkedinPageLists.length === selectedPages.length} label="Select All" onClick={handleSelectAllOption} />
                        </div>
                    ) : null}

                    {linkedinPageLists.map((page) => {
                        let checked = selectedPages.includes(page.page_id);
                        return (
                            <div className="page__list__item" key={page.page_id}>
                                <Checkbox
                                    checked={checked}
                                    label={page.page_name}
                                    onClick={() => (checked ? updatePageSelectionList("remove", page.page_id) : updatePageSelectionList("add", page.page_id))}
                                />
                            </div>
                        );
                    })}
                </Scrollbars>
            </Modal.Content>
            <Modal.Actions>
                <Modal.ActionButton normal onClick={handleCancelAuthentication}>
                    Cancel
                </Modal.ActionButton>
                <Modal.ActionButton filled onClick={handleButtonClick}>
                    Continue
                </Modal.ActionButton>
            </Modal.Actions>
        </Modal>
    );
};

export default LinkedinPageSelectionModal;
